import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-phone-number-input/style.css';
import './Cubicaje.css';
import CustomToolTip from '../../core/CustomToolTip/CustomToolTip';
import { faArrowRight, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomizedSwitch from '../../core/CustomizedSwitch/CustomizedSwitch';
import { UnidadMedidaM, UnidadMedidaPeso } from './DataOptions';
import CustomizedSelect from '../../core/CustomizedSelect/CustomizedSelect';
import CustomMessage from '../../core/CustomMessage/CustomMessage';
import { IFormData, Pallet } from './Cubicaje';
import circleError from '../../assets/images/circle-exclamation-error.svg';
import euroPaletAng from '../../assets/videos/cubicaje/45.png';
import standardAng1 from '../../assets/videos/cubicaje/standard pallet 45.png';
import standardAng from '../../assets/videos/cubicaje/autoelevador-1m-standard.gif';
import euroPalet360 from '../../assets/videos/cubicaje/europallet360.gif';
import standardPalet360_1 from '../../assets/videos/cubicaje/Standard-pallet-360.gif';
import standardPalet360 from '../../assets/videos/cubicaje/autoelevador-1m-standard.gif';
import euroFull from '../../assets/videos/cubicaje/europallet360carga.gif';
import standardFull1 from '../../assets/videos/cubicaje/Standard-pallet-360-cargado.gif';
import standardFull from '../../assets/videos/cubicaje/autoelevador-1m-standard.gif';
import standardFullFemale from '../../assets/videos/cubicaje/autoelevador-1f-standard.gif';
import euroPaletVideo from '../../assets/videos/cubicaje/autoelevador-1m.gif';
import euroPaletVideoFemale from '../../assets/videos/cubicaje/autoelevador-1f.gif';
import { useAvatar } from '../../hooks/useAvatar';
interface Props {
	palletItem: Pallet;
	handleContinueClick: () => void;
	formData: IFormData;
	setFormData: Function;
	onCubicajeSelected: Function;
	setIsLegalModalVisible: Function;
}

type IsVisibleErrors = {
	isErrorCheckMaximumWeight: boolean;
	isErrorCheckMaximumHeight: boolean;
};

const CubicajeSeccionTres: React.FC<Props> = ({
	palletItem,
	handleContinueClick,
	formData,
	setFormData,
	onCubicajeSelected,
	setIsLegalModalVisible,
}) => {
	const { t } = useTranslation();

	const defaultPesoDinamico = palletItem.cargaDinamica;
	const [activePesoMax, setactivePesoMax] = useState(false);
	const [activeAltMax, setactiveAltMax] = useState(false);
	const [pesoDinamico, setPesoDinamico] = useState<number>(defaultPesoDinamico);
	const [unidadMedidaDistancia, setUnidadMedidaDistancia] = useState(formData.unidadMedidaStep2 || 'mm');
	const [unidadMedidaPeso, setUnidadMedidaPeso] = useState(formData.unidadPesoStep2 || 'kg');
	const [showMenssageCargaDinamica, setShowMenssageCargaDinamica] = useState(false);
	const [showMessageCero, setShowMessageCero] = useState(false);
	const [nCajasPallet, setNCajasPallet] = useState<number>(0);
	const [CajasPorPallet, setCajasPorPallet] = useState<number>(0);
	const [cajasCalculado, setCajasCalculado] = useState(0);
	const [showMessageValidator, setShowMessageValidator] = useState(false);
	const [cargaDinamicaSeleccionado] = useState(palletItem.cargaDinamica);
	const [palletAncho] = useState(palletItem.ancho);
	const [palletLargo] = useState(palletItem.largo);
	const cajaAlto = Number(formData.altoStep2);

	const [isMaxSizeValueError, setIsMaxSizeValueError] = useState<boolean>(false);
	const [isMaxLargeValueError, setIsMaxLargeValueError] = useState<boolean>(false);
	const [isLineValueError, setIsLineValueError] = useState<boolean>(false);
	const [maxSize, setMaxSize] = useState<number>(0);
	const [displayValue, setDisplayValue] = useState<string>('');

	const [isCheckMaximumWeight, setIsCheckMaximumWeight] = useState<boolean>(false);
	const [isCheckMaximumHeight, setIsCheckMaximumHeight] = useState<boolean>(false);

	const [isVisibleErrors, setIsVisibleErrors] = useState<IsVisibleErrors>({
		isErrorCheckMaximumWeight: false,
		isErrorCheckMaximumHeight: false,
	});
	const avatar = useAvatar();

	useEffect(() => {
		onCubicajeSelected(
			false,
			palletItem.index === 0
				? avatar === 'women'
					? euroPaletVideoFemale
					: euroPaletVideo
				: avatar === 'women'
					? standardFullFemale
					: standardFull,
		);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (formData.unidadMedidaStep2) {
			setUnidadMedidaDistancia(formData.unidadMedidaStep2);
		}
	}, [formData.unidadMedidaStep2]);

	useEffect(() => {
		if (formData.unidadPesoStep2) {
			setUnidadMedidaPeso(formData.unidadPesoStep2);
		}
	}, [formData.unidadPesoStep2]);

	// Inicializar el peso dinámico en la unidad correcta
	useEffect(() => {
		if (unidadMedidaPeso && defaultPesoDinamico) {
			// Convertir el peso por defecto (que viene en kg) a la unidad seleccionada
			const pesoEnUnidadSeleccionada = convertKgToUnit(defaultPesoDinamico, unidadMedidaPeso);
			setPesoDinamico(pesoEnUnidadSeleccionada);
		}
	}, [unidadMedidaPeso, defaultPesoDinamico]);

	/*ALEX: Acá se calcula la cantidad de filas de acuerdo al peso dinámico */
	useEffect(() => {
		onCubicajeSelected(
			false,
			palletItem.index === 0
				? avatar === 'women'
					? euroPaletVideoFemale
					: euroPaletVideo
				: avatar === 'women'
					? standardFullFemale
					: standardFull,
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	/*ALEX: Acá se calcula la cantidad de filas de acuerdo al peso dinámico */
	useEffect(() => {
		const KCajasXFila = Math.round(CantidadCajasxAncho() * CantidadCajasxLargo());

		// El peso de la caja (formData.pesoStep2) ya viene en kg desde el paso 2
		const pesoCajaEnKg = parseFloat(formData.pesoStep2);
		const PesoFilaCajas = KCajasXFila * pesoCajaEnKg;

		// Convertir el peso dinámico a kilogramos para los cálculos
		const pesoDinamicoEnKg = convertWeightToKg(pesoDinamico, unidadMedidaPeso);
		// cargaDinamicaSeleccionado ya viene en kg desde palletItem.cargaDinamica
		const cargaDinamicaSeleccionadoEnKg = cargaDinamicaSeleccionado;
		// pesoPalletUnidad ya viene en kg desde palletItem.pesoPalletUnidad
		const pesoPalletUnidadEnKg = palletItem.pesoPalletUnidad;

		let cargaPosibleCajasPeso = cargaDinamicaSeleccionadoEnKg - pesoPalletUnidadEnKg;
		if (pesoDinamicoEnKg > 0) {
			cargaPosibleCajasPeso = pesoDinamicoEnKg - pesoPalletUnidadEnKg;
		}

		let varKFilasMaxPeso = Math.floor(cargaPosibleCajasPeso / PesoFilaCajas); // Tomamos la parte entera

		const cajaAlto = parseFloat(formData.altoStep2);
		let cargaPosibleCajasAltura = Infinity; // Valor alto por defecto

		// Si no hay un maxSize definido por el usuario, usamos el límite estándar de 2145mm
		const alturaMaximaPermitida = maxSize > 0 ? maxSize : 2145;
		if (cajaAlto > 0) {
			cargaPosibleCajasAltura = Math.floor((alturaMaximaPermitida - palletItem.alto) / cajaAlto); // Tomamos la parte entera
		}

		// Tomamos el menor valor entre las dos restricciones
		const cargaPosibleCajas = Math.min(varKFilasMaxPeso, cargaPosibleCajasAltura);

		setFormData((prevData: IFormData) => ({
			...prevData,
			KcajasXFila: KCajasXFila.toString(),
			PesoFilaCajas: PesoFilaCajas.toString(),
			FilasMaximoAltura: cargaPosibleCajas.toString(),
			FilasMaximoPeso: cargaPosibleCajas.toString(),
			PesoMaximo: pesoDinamicoEnKg || 0,
			AlturaMaxima: alturaMaximaPermitida,
		}));

		setNCajasPallet(cargaPosibleCajas);
		setCajasCalculado(cargaPosibleCajas);
		setCajasPorPallet(cargaPosibleCajas);

		function CantidadCajasxAncho() {
			const anchoCaja = parseFloat(formData.anchoStep2);
			return Math.floor(palletAncho / anchoCaja);
		}

		function CantidadCajasxLargo() {
			const largoCaja = parseFloat(formData.largoStep2);
			return Math.floor(palletLargo / largoCaja);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cargaDinamicaSeleccionado, palletAncho, palletLargo, pesoDinamico, maxSize, unidadMedidaPeso]);

	useEffect(() => {
		setFormData((prevData: IFormData) => ({
			...prevData,
			FilasMaximoAltura: CajasPorPallet.toString(),
		}));
	}, [CajasPorPallet]);

	function handlePesoMaximo(arg0: boolean) {
		setactivePesoMax(arg0);
	}

	function handleAlturaMax(arg0: boolean) {
		setactiveAltMax(arg0);
	}

	function handleMeidaDis(value: string) {
		setUnidadMedidaDistancia(value);

		// Si hay un valor en maxSize, convertir el display value a la nueva unidad
		if (maxSize > 0) {
			const newDisplayValue = convertMmToUnit(maxSize, value);
			setDisplayValue(newDisplayValue.toString());
		}
	}

	// Función para convertir de mm a la unidad seleccionada
	function convertMmToUnit(valueInMm: number, unit: string): number {
		switch (unit) {
			case 'cm':
				return valueInMm / 10;
			case 'm':
				return valueInMm / 1000;
			case 'in':
				return valueInMm / 25.4;
			case 'ft':
				return valueInMm / 304.8;
			case 'mm':
			default:
				return valueInMm;
		}
	}

	// Función para convertir cualquier unidad de peso a kilogramos
	function convertWeightToKg(value: number, unit: string): number {
		switch (unit) {
			case 'mg':
				return value / 1000000; // 1 kg = 1,000,000 mg
			case 'g':
				return value / 1000; // 1 kg = 1,000 g
			case 'kg':
				return value; // Ya está en kg
			case 'libra':
				return value * 0.453592; // 1 libra = 0.453592 kg
			case 'onza':
				return value * 0.0283495; // 1 onza = 0.0283495 kg
			default:
				return value; // Por defecto asumimos kg
		}
	}

	// Función para convertir de kilogramos a la unidad seleccionada
	function convertKgToUnit(valueInKg: number, unit: string): number {
		switch (unit) {
			case 'mg':
				return valueInKg * 1000000; // 1 kg = 1,000,000 mg
			case 'g':
				return valueInKg * 1000; // 1 kg = 1,000 g
			case 'kg':
				return valueInKg; // Ya está en kg
			case 'libra':
				return valueInKg / 0.453592; // 1 kg = 2.20462 libras
			case 'onza':
				return valueInKg / 0.0283495; // 1 kg = 35.274 onzas
			default:
				return valueInKg; // Por defecto asumimos kg
		}
	}

	const validateActiveWeightValues = () => {
		if (activePesoMax) {
			if (pesoDinamico === undefined || pesoDinamico === null) {
				setIsMaxSizeValueError(true);
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	};

	const validateMaxSizeValues = () => {
		if (activeAltMax) {
			if (maxSize === undefined || maxSize === null) {
				setIsMaxLargeValueError(true);
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	};

	const onValidate = () => {
		if (isCheckMaximumWeight && isCheckMaximumHeight && !isMaxSizeValueError && !isMaxLargeValueError) {
			if (nCajasPallet === undefined || nCajasPallet === null || nCajasPallet === 0 || isNaN(nCajasPallet)) {
				setIsLineValueError(true);
			}

			if (validateActiveWeightValues() && validateMaxSizeValues() && nCajasPallet) {
				handleContinueClick();
			}
		} else {
			setIsVisibleErrors((preValue) => ({
				...preValue,
				isErrorCheckMaximumWeight: !isCheckMaximumWeight,
				isErrorCheckMaximumHeight: !isCheckMaximumHeight,
			}));
		}
	};

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<div>
			{showMenssageCargaDinamica && (
				<CustomMessage
					background={'#F4B400'}
					textMessage={t('cubicaje.step_3.message_1')}
				/>
			)}

			{showMessageCero && (
				<CustomMessage
					background={'#F4B400'}
					textMessage={t('cubicaje.step_3.message_2')}
				/>
			)}
			<form>
				<div className="mb-3">
					<label className="form-label"> {t('cubicaje.step_3.item_1.title')}</label>
					<CustomizedSwitch
						onChange={([activePesoMax]) => {
							// if (activePesoMax) {
							//   onCubicajeSelected(
							//     false,
							//     palletItem.titlePallet === "Europalet"
							//       ? euroPaletAng
							//       : standardAng
							//   );
							// } else {
							//   onCubicajeSelected(
							//     false,
							//     palletItem.titlePallet === "Europalet"
							//       ? euroFull
							//       : standardFull
							//   );
							// }
							handlePesoMaximo(activePesoMax);
							setIsCheckMaximumWeight(true);
							setIsVisibleErrors((preValue) => ({
								...preValue,
								isErrorCheckMaximumWeight: false,
							}));
							setIsMaxSizeValueError(activePesoMax);
						}}
						checked={activePesoMax}
					/>
				</div>
				{isVisibleErrors.isErrorCheckMaximumWeight && (
					<div className="container errorContainer">
						<img
							src={circleError}
							alt="error-icon"
						/>
						<p className="errorInputValidation">{t('cubicaje.step_3.selectOption')}</p>
					</div>
				)}
				{activePesoMax && (
					<div className="rowcubicaje-container rowcubicaje-container-doblerow">
						<div className="rowcubicaje-col rowcubicaje-min">
							<CustomizedSelect
								title={'Unidad'}
								options={UnidadMedidaPeso}
								value={unidadMedidaPeso}
								onChange={(value) => {
									// Convertir el valor actual a kg y luego a la nueva unidad
									const pesoEnKg = convertWeightToKg(pesoDinamico, unidadMedidaPeso);
									const nuevoPesoEnNuevaUnidad = convertKgToUnit(pesoEnKg, value);
									setPesoDinamico(nuevoPesoEnNuevaUnidad);
									setUnidadMedidaPeso(value);
								}}
							/>
						</div>
						<div className="rowcubicaje-rightmin container-label">
							<input
								type="number"
								value={pesoDinamico}
								onChange={(e) => {
									e.preventDefault();
									const nuevoValor = parseFloat(e.currentTarget.value);
									setPesoDinamico(nuevoValor);
									setIsMaxSizeValueError(e.currentTarget.value === '');

									// Convertir ambos valores a kg para la comparación
									const pesoDinamicoEnKg = convertWeightToKg(nuevoValor, unidadMedidaPeso);
									const cargaDinamicaEnKg = convertWeightToKg(cargaDinamicaSeleccionado, unidadMedidaPeso);

									if (pesoDinamicoEnKg > cargaDinamicaEnKg) {
										setShowMenssageCargaDinamica(true);
									} else {
										if (nuevoValor <= 0 || e.currentTarget.value === undefined || e.currentTarget.value === null) {
											setShowMessageCero(true);
										} else {
											setShowMessageCero(false);
										}
										setShowMenssageCargaDinamica(false);
									}
								}}
								className="inputItem shortInput"
							/>
							<label className="form-label">{t('cubicaje.step_3.item_1.placeholder')}</label>
						</div>
						{isMaxSizeValueError && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{t('cubicaje.step_3.required')}</p>
							</div>
						)}
					</div>
				)}
				<div className="mb-3 mt-3">
					<label className="form-label">{t('cubicaje.step_3.item_2.title')}</label>

					<CustomizedSwitch
						onChange={([activeAltMax]) => {
							// if (activeAltMax) {
							//   onCubicajeSelected(
							//     false,
							//     palletItem.titlePallet === "Europalet"
							//       ? euroPalet360
							//       : standardPalet360
							//   );
							// }
							handleAlturaMax(activeAltMax);
							setIsCheckMaximumHeight(true);
							setIsVisibleErrors((preValue) => ({
								...preValue,
								isErrorCheckMaximumHeight: false,
							}));
							setIsMaxLargeValueError(activeAltMax);
						}}
						checked={activeAltMax}
					/>
				</div>
				{isVisibleErrors.isErrorCheckMaximumHeight && (
					<div className="container errorContainer">
						<img
							src={circleError}
							alt="error-icon"
						/>
						<p className="errorInputValidation">{t('cubicaje.step_3.selectOption')}</p>
					</div>
				)}
				{activeAltMax && (
					<div className="rowcubicaje-container rowcubicaje-container-doblerow">
						<div className="rowcubicaje-col rowcubicaje-min">
							<div className="CustomizedSelect__container">
								<div className="CustomizedSelect__title">{t('cubicaje.step_3.unit')}</div>
								<div className="country-info">
									<select
										style={{ maxWidth: 65 }}
										defaultValue={unidadMedidaDistancia}
										onChange={(e) => {
											handleMeidaDis(e.currentTarget.value);
										}}>
										{UnidadMedidaM.map((option, index) => (
											<option
												key={index}
												value={option}>
												{option}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>
						<div className="rowcubicaje-col rowcubicaje-min rowcubicaje-rightmin container-label">
							<input
								type="text"
								className="inputItem shortInput"
								value={displayValue}
								onChange={(e) => {
									e.preventDefault();
									const value = parseFloat(e.currentTarget.value);
									setDisplayValue(e.currentTarget.value);

									// Convertir a milímetros según la unidad seleccionada
									let valueInMm = value;
									switch (unidadMedidaDistancia) {
										case 'cm':
											valueInMm = value * 10;
											break;
										case 'm':
											valueInMm = value * 1000;
											break;
										case 'in':
											valueInMm = value * 25.4;
											break;
										case 'ft':
											valueInMm = value * 304.8;
											break;
										case 'mm':
										default:
											valueInMm = value;
											break;
									}

									setMaxSize(valueInMm);
									setIsMaxLargeValueError(e.currentTarget.value === '');
								}}
							/>
							<label className="form-label">{t('cubicaje.step_3.item_2.placeholder')}</label>
						</div>
						{isMaxLargeValueError && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{t('cubicaje.step_3.required')}</p>
							</div>
						)}
					</div>
				)}
				<div className="mb-3 mt-3">
					<label className="form-label">{t('cubicaje.step_3.item_3.title')}</label>
					<div className="selectCantidadPallet container-label">
						<input
							type="number"
							// value={nCajasPallet}
							value={CajasPorPallet}
							min={0}
							onChange={(e) => {
								// onCubicajeSelected(
								//   false,
								//   palletItem.titlePallet === "Europalet"
								//     ? euroFull
								//     : standardFull
								// );
								e.preventDefault();
								setNCajasPallet(parseFloat(e.currentTarget.value));
								setCajasPorPallet(parseFloat(e.currentTarget.value));
								setIsLineValueError(false);
								if (parseFloat(e.currentTarget.value) <= cajasCalculado) {
									setShowMessageValidator(false);
									const varKFilasMaxPeso = Math.round(
										parseFloat(formData.PesoFilaCajas) / parseFloat(e.currentTarget.value),
									);
									setFormData((prevData: IFormData) => ({
										...prevData,
										newCalculoPesoFilasMax: varKFilasMaxPeso.toString(),
									}));
									setIsLineValueError(false);
								} else {
									setShowMessageValidator(true);
								}
							}}
							className="cubicaje-information__textbox-general"
						/>
						<label className="form-label">{t('cubicaje.step_3.item_3.placeholder')}</label>
						<div style={{ marginLeft: '15px' }}>
							<CustomToolTip
								title=""
								tooltipText={t('cubicaje.step_3.item_3.tooltip')}>
								<FontAwesomeIcon
									icon={faCircleQuestion}
									className="font-size: 15px"
								/>
							</CustomToolTip>
						</div>
					</div>
					{showMessageValidator && (
						<CustomMessage
							background={`#F4B400`}
							textMessage={`${t('cubicaje.step_3.message_3a')} ${cajasCalculado}, ${t('cubicaje.step_3.message_3b')}`}
						/>
					)}
				</div>
				{isLineValueError && (
					<div className="container errorContainer">
						<img
							src={circleError}
							alt="error-icon"
						/>
						<p className="errorInputValidation">{t('cubicaje.step_3.required')}</p>
					</div>
				)}
			</form>
			<div className="mainContainerFooter">
				<div
					className="see_legals"
					onClick={() => setIsLegalModalVisible(true)}>
					<p>{t('cubicaje.legal')}</p>
				</div>
				<div
					className="cubicaje-information__next"
					onClick={onValidate}>
					<div className="btn-test-next-text">{t('cubicaje.button')}</div>
					<FontAwesomeIcon
						icon={faArrowRight}
						color="black"
					/>
				</div>
			</div>
		</div>
	);
};

export default CubicajeSeccionTres;
